import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { useState } from 'react'

import i18n from '../i18n/index'

const useStyles = makeStyles((theme) => ({
  language: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  textColor: {
    color: theme.palette.primary.main,
    fontFamily: 'Neo Sans Pro',
    underline: true,
  },
  buttonUK: {
    textDecoration: 'underline',
    '&:focus': {
      textDecoration: 'underline',
    },
    '&:active': {
      textDecoration: 'underline',
    },
  },
  buttonEN: {
    textDecoration: 'underline',
    '&:focus': {
      textDecoration: 'underline',
    },
    '&:active': {
      textDecoration: 'underline',
    },
  },
  buttonRU: {
    textDecoration: 'underline',
    '&:focus': {
      textDecoration: 'underline',
    },
    '&:active': {
      textDecoration: 'underline',
    },
  },

  notActive: {
    textDecoration: 'none',
  },
}))

function LanguageSwitch({ t }) {
  const classes = useStyles()
  const defaultLanguage = i18n.language = 'uk'
  const [activeButton, setActiveButton] = useState(defaultLanguage)
  let buttonStyleUK
  let buttonStyleRU
  let buttonStyleEN

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  if (activeButton === 'uk') {
    buttonStyleUK = classes.buttonUK // Use useStyle to create the 'active' class
  }
  if (activeButton === 'ru') {
    buttonStyleRU = classes.buttonRU // Use useStyle to create the 'active' class
  }
  if (activeButton === 'en') {
    buttonStyleEN = classes.buttonEN // Use useStyle to create the 'active' class
  }
  return (
    <Grid className={classes.language}>
      <Button
        className={buttonStyleUK}
        onClick={() => {
          changeLanguage('uk')
          setActiveButton('uk')
        }}
      >
        <Typography className={classes.textColor}>{'УКР'}</Typography>
      </Button>
      <Button
        onClick={() => {
          changeLanguage('ru')
          setActiveButton('ru')
        }}
        className={buttonStyleRU}
      >
        <Typography className={classes.textColor}>{'РУС'}</Typography>
      </Button>
      <Button
        onClick={() => {
          changeLanguage('en')
          setActiveButton('en')
        }}
        className={buttonStyleEN}
      >
        <Typography className={classes.textColor}>{'ENG'}</Typography>
      </Button>
    </Grid>
  )
}

export default LanguageSwitch
